module.exports = __webpack_public_path__ + "img/DIENTE_PROVISIONAL_MAL_ESTADO.png";